"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _IconButtons = require("./IconButtons");
Object.keys(_IconButtons).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _IconButtons[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _IconButtons[key];
    }
  });
});
var _PointsOrDealLabel = require("./PointsOrDealLabel");
Object.keys(_PointsOrDealLabel).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PointsOrDealLabel[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PointsOrDealLabel[key];
    }
  });
});
var _ProductImage = require("./ProductImage");
Object.keys(_ProductImage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ProductImage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ProductImage[key];
    }
  });
});
var _PricesSection = require("./PricesSection");
Object.keys(_PricesSection).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PricesSection[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PricesSection[key];
    }
  });
});
var _Rating = require("./Rating");
Object.keys(_Rating).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Rating[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Rating[key];
    }
  });
});
var _Shades = require("./Shades");
Object.keys(_Shades).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Shades[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Shades[key];
    }
  });
});
var _SubscriptionLabel = require("./SubscriptionLabel");
Object.keys(_SubscriptionLabel).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SubscriptionLabel[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SubscriptionLabel[key];
    }
  });
});
//# sourceMappingURL=index.js.map